import { FlujoTesoreriaReadingFiltersDtoProps } from "./DTOs/FlujoTesoreriaReadingFiltersDto"
import { GetFlujoDeTesoreriaDisponibleByFacturaQueryDto } from "./DTOs/GetFlujoDeTesoreriaDisponibleByFacturaQueryDto"
import { GetFlujosConciliablesDtoProps } from "./DTOs/GetFlujosConciliablesDto"

export const pagosCobrosDisponiblesAdapter = (
  pagoCobro: GetFlujoDeTesoreriaDisponibleByFacturaQueryDto
): GetFlujoDeTesoreriaDisponibleByFacturaQueryDto => {
  return {
    id: pagoCobro.id,
    descripcion: pagoCobro.descripcion ?? "",
    fecha: pagoCobro.fecha,
    importe: pagoCobro.importe,
    numero: pagoCobro.numero,
  }
}

export function flujoTesoreriaReadingFiltersDtoPropsAdapter(
  flujoTesoreria: FlujoTesoreriaReadingFiltersDtoProps
): FlujoTesoreriaReadingFiltersDtoProps {
  return {
    id: flujoTesoreria.id,
    conciliacion: flujoTesoreria.conciliacion,
    cuentaBancaria: flujoTesoreria.cuentaBancaria,
    descripcion: flujoTesoreria.descripcion,
    documento: flujoTesoreria.documento,
    facturaId: flujoTesoreria.facturaId,
    fecha: flujoTesoreria.fecha,
    identificador: flujoTesoreria.identificador,
    importe: flujoTesoreria.importe,
    razonSocial: flujoTesoreria.razonSocial,
    tipo: flujoTesoreria.tipo,
    tipoRemesable: flujoTesoreria.tipoRemesable,
  }
}

export const getFlujosConciliablesAdapter = (
  flujoTesoreria: GetFlujosConciliablesDtoProps
): GetFlujosConciliablesDtoProps => ({
  id: flujoTesoreria?.id,
  asientoContable: flujoTesoreria?.asientoContable,
  descripcion: flujoTesoreria?.descripcion,
  fecha: flujoTesoreria?.fecha,
  identificador: flujoTesoreria?.identificador,
  importe: flujoTesoreria?.importe,
  empresa: flujoTesoreria?.empresa,
  tipo: flujoTesoreria?.tipo,
})
